import { Model } from "@vuex-orm/core";
import config from "../configs/Mandate";

import BuildingOwner from "./BuildingOwner";
import Contact from "./Contact";
import Media from "./Media";
import ResolutionVote from "./ResolutionVote";
import Docage from "./Docage";

import BuildingOwnerBuildingLot from "./BuildingOwnerBuildingLot";

export default class Mandate extends Model {
  static get entity() {
    return "mandates";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      meeting_id: this.attr(null),
      building_owner_id: this.attr(null),
      representant_owner_id: this.attr(null),
      representant_contact_id: this.attr(null),

      identifier: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..

      voting_rights: this.attr(null),
      voting_instructions: this.attr(null),
      last_seen: this.attr(null),
      just_arrived_by_video: this.attr(null),
      dummy_video_presence_status: this.attr(null),
      //
      invitation_id: this.attr(null),
      pouvoir_id: this.attr(null),
      voting_form_id: this.attr(null),
      merged_media_id: this.attr(null),
      email_status: this.attr(null),
      docs_status: this.attr(null),
      //

      //
      invitation_pdf: this.belongsTo(Media, "invitation_id"),
      pouvoir_pdf: this.belongsTo(Media, "pouvoir_id"),
      voting_form_pdf: this.belongsTo(Media, "voting_form_id"),
      merged_pdf: this.belongsTo(Media, "merged_media_id"),
      reception_date: this.attr(null),
      //

      showed_up: this.attr(null),
      // NOTE: Maybe we do not need this
      voted_by_correspondence: this.attr(null),
      presence_status: this.attr(null),
      last_presence_status: this.attr(null),
      presence_intention: this.attr(null),

      building_owner: this.belongsTo(BuildingOwner, "building_owner_id"),
      // HACK: .. ..
      representant_owner: this.belongsTo(BuildingOwner, "representant_owner_id"),
      representant_contact: this.belongsTo(Contact, "representant_contact_id"),
      // ..
      resolution_votes: this.hasMany(ResolutionVote, "mandate_id"),

      // HACK: for tantiemes in meeting-start
      building_owner_building_lots: this.hasMany(
        BuildingOwnerBuildingLot,
        "building_owner_id",
        "building_owner_id"
      ),
      merged_pv_media: this.belongsTo(Media, "merge_pv_media_id"),
      merged_pv_media_id: this.attr(null),
      agency_preferred_broadcast: this.attr(null),
      agency_preferred_invitation_broadcast: this.attr(null),
      meeting_correspondence_votes: this.attr(null),
      // NOTE: Used only locally
      is_selected: this.attr(false),
      doc_requests: this.attr(null),

      individual_additional_file_invitation: this.hasMany(
        Media,
        "individual_file_invitation_mandate_id"
      ),
      individual_additional_files_pv: this.hasMany(Media, "individual_file_pv_mandate_id"),
      docage_id: this.attr(null),
      docage: this.belongsTo(Docage, "docage_id"),
    };
  }
  static get apiConfig() {
    return config;
  }
}
